import { render, staticRenderFns } from "./GroupOfAccreditationInfo.vue?vue&type=template&id=54aa85c5"
import script from "./GroupOfAccreditationInfo.vue?vue&type=script&lang=js"
export * from "./GroupOfAccreditationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports